import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Experience from './components/Experience';
import Process from './components/Process';
import Specialism from './components/Specialism';
import Advantages from './components/Advantages';
import Ethos from './components/Ethos';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';

const Home = () => (
  <div className="App bg-[#0f0f10] text-white">
    <Navbar />
    <Hero />
    <Marquee />
    <Experience />
    <Process />
    <Specialism />
    <Advantages />
    <Ethos />
    <Testimonials />
    <FAQ />
    <Contact />
    <Footer />
    <Toaster />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
